(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psw-category-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var hoverOK = window.matchMedia('(hover: hover) and (pointer: fine)');

    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var tabs = [].slice.call(root.querySelectorAll('[data-tab]'));
      var slides = [].slice.call(root.querySelectorAll('[data-slide]'));
      var panels = [].slice.call(root.querySelectorAll('[data-panel]'));
      var nav = root.querySelector('[data-nav]');
      var current = -1;
      var visible = true;

      function canPlay() {
        var c = navigator.connection;
        return !reduce.matches && !(c && c.saveData);
      }
      function startVideo(slide) {
        var v = slide.querySelector('video');
        if (!v || !canPlay() || !visible) return;
        if (!v.getAttribute('src')) {
          v.muted = true;
          v.addEventListener('playing', function () { v.classList.add('is-playing'); });
          v.src = v.dataset.src;
        }
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
      function stopVideo(slide) {
        var v = slide.querySelector('video');
        if (v && v.getAttribute('src')) v.pause();
      }

      function show(i) {
        if (i === current || !slides[i]) return;
        current = i;
        slides.forEach(function (s, k) {
          var on = k === i;
          s.classList.toggle('is-active', on);
          if (on) startVideo(s); else stopVideo(s);
        });
        panels.forEach(function (p, k) {
          var on = k === i;
          p.classList.toggle('is-active', on);
          if (on) { p.removeAttribute('inert'); p.removeAttribute('aria-hidden'); }
          else { p.setAttribute('inert', ''); p.setAttribute('aria-hidden', 'true'); }
        });
        tabs.forEach(function (t, k) { t.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        if (nav && nav.scrollWidth > nav.clientWidth) {
          nav.scrollTo({ left: Math.max(tabs[i].offsetLeft - 8, 0), behavior: reduce.matches ? 'auto' : 'smooth' });
        }
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(i); });
        t.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' && hoverOK.matches) show(i); });
        t.addEventListener('focus', function () { show(i); });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          tabs[(i + d + tabs.length) % tabs.length].focus();
        });
      });

      /* Pausa o video quando o hero sai da tela */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[0].isIntersecting;
          if (current < 0) return;
          if (visible) startVideo(slides[current]); else stopVideo(slides[current]);
        }, { threshold: 0.15 }).observe(root);
      }

      show(0);
    }

    function initAll() { document.querySelectorAll('[data-psw-hero]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
    /* No editor de temas: selecionar um bloco abre aquela categoria */
    document.addEventListener('shopify:block:select', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-tab')) e.target.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psw-video-reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var cards = [].slice.call(root.querySelectorAll('.psw-reels__card'));
      function stopOthers(except) {
        cards.forEach(function (c) {
          if (c === except) return;
          var v = c.querySelector('video');
          if (v && !v.paused) { v.pause(); }
          c.classList.remove('is-playing');
        });
      }
      cards.forEach(function (card) {
        var v = card.querySelector('video');
        var btn = card.querySelector('[data-play]');
        if (!v || !btn) return;
        btn.addEventListener('click', function () {
          stopOthers(card);
          v.muted = false;
          v.controls = true;
          card.classList.add('is-playing');
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        });
        v.addEventListener('pause', function () { if (v.ended || v.currentTime === 0) card.classList.remove('is-playing'); });
      });
    }
    function initAll() { document.querySelectorAll('[data-psw-reels]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
